<!--
 * @Description:转化记录 - 线索/客户详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-08 10:34:45
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" @fetch="fetch" :tableId="tableIdByPath('conversion')"> </cos-table>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { conversionList as conversionListFbu } from '@/api/gucangSales/customerCenter'
import { conversionList as conversionListOfbu } from '@/api/overseasSales/customerCenter'
import { conversionList as conversionListLbu } from '@/api/yuntuSales/customerCenter'
import { tableIdByPath } from '@/utils'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  resourceId: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: true
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
})
const conversionListMethod = {
  cos_fbu: conversionListFbu,
  cos_ofbu: conversionListOfbu,
  cos_lbu: conversionListLbu
}
const fetch = (params: object, callBack: (res: any) => void) => {
  if (props.resourceId) {
    conversionListMethod[props.appId]({
      resourceId: props.resourceId,
      ...params
    }).then((res: any) => {
      callBack(res)
    })
  }
}
const columns = computed(() => [
  { title: t('common.operator'), dataIndex: 'createByName' },
  { title: t('common.operatorDate'), dataIndex: 'createTime' },
  {
    title: t('common.operationType'),
    dataIndex: 'operateType'
    // dicData: [
    //   { label: t('enum.operateType1'), value: 1 },
    //   { label: t('enum.operateType2'), value: 2 },
    //   { label: t('enum.operateType3'), value: 3 },
    //   { label: t('enum.operateType4'), value: 4 },
    //   { label: t('enum.operateType5'), value: 5 },
    //   { label: t('enum.operateType6'), value: 6 },
    //   { label: t('enum.operateType7'), value: 7 },
    //   { label: t('enum.operateType8'), value: 8 },
    //   { label: t('enum.operateType9'), value: 9 }
    // ]
  },
  { title: t('common.operatorBefore '), dataIndex: 'beforeData' },
  { title: t('common.operatorAfter'), dataIndex: 'afterData' }
])
</script>
<script lang="ts">
export default { name: 'TabsConversion' }
</script>
<style lang="scss" scoped></style>
